export const UNKNOWN_CALLABLE_ERROR_MESSAGE = 'Ismeretlen hiba történt.'
export const SIGN_IN_REQUIRED_MESSAGE = 'Csak bejelentkezett felhasználók használhatják ezt a funkciót.'

type CallableError = { code?: string; details?: { message?: string } }

export function callableErrorMessage(error: unknown, fallback = UNKNOWN_CALLABLE_ERROR_MESSAGE): string {
  const { code, details } = (error ?? {}) as CallableError
  return details?.message ?? (code === 'functions/unauthenticated' ? SIGN_IN_REQUIRED_MESSAGE : fallback)
}
